// extracted by mini-css-extract-plugin
export default {"documentRunsTableSection":"styles_documentRunsTableSection__QWrnw"};